import { render, staticRenderFns } from "./AddGroupButton.vue?vue&type=template&id=2eb7b5a6&scoped=true&"
import script from "./AddGroupButton.vue?vue&type=script&lang=js&"
export * from "./AddGroupButton.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupButton.vue?vue&type=style&index=0&id=2eb7b5a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb7b5a6",
  null
  
)

component.options.__file = "AddGroupButton.vue"
export default component.exports